// extracted by mini-css-extract-plugin
export default {"outer-wrapper":"styles_outer-wrapper__zBDSr","button":"styles_button__0Bnh-","star":"styles_star__igsgH","product-image-container":"styles_product-image-container__44dJM"};